<ng-container *ngIf="loading === GenLoadingEnum.Loaded && !!user;">
  <gen-header-navigation *ngIf="data$ | async as data" [node]="node$ | async" [ngClass]="data.styleClass ?? ''"
    [wrapAfter]="+(data.wrapAfter ?? '1')" [resetMenuOnClose]="data.resetMenuOnClose"
    [navAriaLabel]="'navigation.categoryNavLabel' | cxTranslate"></gen-header-navigation>
</ng-container>
<ng-container *ngIf="loading === GenLoadingEnum.Loaded && !user;">
  <a role="link" [routerLink]="{ cxRoute: 'login' } | cxUrl">
    {{ "miniLogin.signInRegister" | cxTranslate }}
  </a>
</ng-container>